import authTemplates from './authTemplates';
import dummyScreen from './dummyScreen';
import general from './general';
import unitTitles from './general/unitTitles';
import task from './task';
import team from './team';
import menu from './menu';
import registration from './registration';
import dashboard from './dashboard';
import user from './user';
import fleet from './fleet';
import pagination from './pagination';
import phoneNumber from './phoneNumber';
import business from './business';
import businessTypes from './businessTypes';
import farmTypes from './farmTypes';
import smartFarming from './smartFarming';
import landingPage from './landingPage';
import dataAndPrivacy from './dataAndPrivacy';
import cpq from './cpq';
import categories from './categories';
import pageNotFound from './pageNotFound';

export const commonMessages = {
  dummyScreen,
  general,
  unitTitles,
  task,
  team,
  authTemplates,
  menu,
  registration,
  dashboard,
  user,
  fleet,
  pagination,
  phoneNumber,
  business,
  businessTypes,
  farmTypes,
  smartFarming,
  landingPage,
  dataAndPrivacy,
  cpq,
  categories,
  pageNotFound,
};
